import ContentsDispatcher from "./ContentsDispatcher";
import { useMapColorState } from "../../../store/MapColorState";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { MAP_ID_TILEMAP, mapContentsVisibleWithID } from "../../../store/MapContentsState";

const TileMapDispatcher = (props) => {
  const setTileMapVisible = useSetRecoilState(mapContentsVisibleWithID(MAP_ID_TILEMAP));
  const {isGoogleMap} = useMapColorState();

  useEffect(() => {
    //GoogleMapがOnになったらTileMapは非表示にする
    //GoogleMapがOffになったらTileMapを表示する
    setTileMapVisible(!isGoogleMap);
  },[isGoogleMap, setTileMapVisible]);

  return <ContentsDispatcher {...props}/>
};

export default TileMapDispatcher;